export default __webpack_public_path__ + "static/media/ROM SYLLABUS_2026-27 CLASS 7.98d58eae.pdf";